import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_4: FaireProductEntity = {
  token: "matcha-4",
  type: "product",
  name: "Matcha Enzyme Mask",
  brandName: "The Park after Dark",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/42d9c083060cf7cb95b685bcced3543a77817b55497a69bea6bde19292b8b6fc.png",
  priceDollars: 3,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/42d9c083060cf7cb95b685bcced3543a77817b55497a69bea6bde19292b8b6fc.png",
  weight: 0.4,
  dimensions: {
    width: 3,
    height: 3,
    depth: 3,
  },
  description: "Matcha enzyme face mask for glowing skin",
  categoryTokens: ["cat_bath-all"],
  tags: ["matcha", "skincare", "face-mask", "wellness", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
